import { call } from 'redux-saga/effects';
import { syncStateToLocalStorage } from '../helpers/window-storage.helper';
import { store } from './';

// State used to be written to local storage only from an `unload` listener.
// Chrome now blocks `unload` behind a permissions policy ("Permissions policy
// violation: unload is not allowed in this document"), and it is skipped for
// bfcache navigations anyway, so nothing was ever persisted: every full page
// load restored whatever local storage happened to hold from an older session -
// most importantly a stale (or missing) franchisor, which is what
// `X-Franchisor-Id` is built from. Leaving the app for an external payment
// gateway and coming back is exactly that flow, and the callback request then
// runs against the wrong tenant.
//
// Persist on every change to the two slices we store instead, and keep a
// `pagehide` flush for the last state before the document goes away.
function stateSync() {
    let lastAuth = store.getState().auth;
    let lastRoot = store.getState().root;

    const persist = () => syncStateToLocalStorage(store.getState());

    store.subscribe(() => {
        const { auth, root } = store.getState();
        // reducers return new references only when the slice actually changed
        if (auth === lastAuth && root === lastRoot) {
            return;
        }

        lastAuth = auth;
        lastRoot = root;
        persist();
    });

    window.addEventListener('pagehide', persist);
}

export const stateSyncEffects = [
    call(stateSync),
];
